import React from 'react';
import {Container, Paper, TextField, Typography, Button, Grid} from '@material-ui/core';
import {AddCircle, Cancel} from '@material-ui/icons';
import useStyles from '../styles';

function Schweissnahtpruefung(props) {
    const classes = useStyles();

    return (
        <Container maxWidth="sm" className={classes.container}>
            <Paper className={classes.containerPaper}>
                <Typography variant="h4" component="h1">Schweißnahtprüfung</Typography>
                <TextField
                    fullWidth
                    label="System-ID"
                    className={classes.textField}
                    margin="normal"
                />
                <TextField
                    label="Position"
                    fullWidth
                    multiline
                    rows="3"
                    className={classes.textField}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="Verfahren"
                    className={classes.textField}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="Schweißer"
                    className={classes.textField}
                    margin="normal"
                />
                <TextField
                    fullWidth
                    label="Prüfnummer"
                    className={classes.textField}
                    margin="normal"
                />
                <Typography variant="h6" component="h2">Meldung</Typography>
                <Typography variant="body1">Hier steht eine beispielhafte Meldung für Demonstrationszwecke.</Typography>
                <Grid container justify="space-between" className={classes.buttonsBelowForm}>
                    <Button color="primary" size="large">
                        <AddCircle className={classes.buttonIcon}/>Buchen
                    </Button>
                    <Button size="large">
                        <Cancel className={classes.buttonIcon}/>Abbrechen
                    </Button>
                </Grid>
            </Paper>
        </Container>
    );
}

export default Schweissnahtpruefung;